import { DownloadResultLimiter } from "@/services/license/license-limiters/base-limiters/download-result-limiter";
import { LicenseName } from "@/data/license.data";

export class DuetsDownloadResultLimiter extends DownloadResultLimiter {
  isDownloadEnabled(license: LicenseName) {
    return license === "Creator" || license === "Studio";
  }
}
